import styled from "styled-components"

export const RichTextAreaContainer = styled.div`
  background-color: #f1f9fc;
  padding: 80px 0;
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 16px;
    color: ${props => props.theme.colors.darkBlue};
  }

  p {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 16px;
  }
  p:last-child {
    margin-bottom: 0;
  }
`
